import { memo, useEffect, useState, useCallback } from "react";
import { Document, Page, pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.12.313/pdf.worker.js`;
const PdfPreview = memo(({ file }) => {
  const [pageCount, setPageCount] = useState(0);
  return (
    <Document
      file={file}
      onLoadError={(err) => console.log("onload err", err)}
      onLoadSuccess={({ numPages }) => setPageCount(numPages)}
    >
      {Array.from(new Array(pageCount), (el, index) => (
        <Page
          key={index}
          pageNumber={index + 1}
          renderAnnotationLayer={false}
          renderTextLayer={false}
        />
      ))}
    </Document>
  );
});
const Pdfview = ({ viewPdf }) => {
  const [existingdataList, setExistingdataList] = useState([]);
  const [fileParseDone, setFileParseDone] = useState(false);

  const getExistingFileData = useCallback((fileDetails) => {
    try {
      const data = fileDetails.map((file) => {
        const byteCharacters = atob(file.fileContent);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });
        return blob;
      });
      setExistingdataList(data);
      setFileParseDone(true);
    } catch (err) {
      console.log(err);
      setFileParseDone(false);
    }
  }, []);

  useEffect(() => {
    if (viewPdf?.length > 0) {
      getExistingFileData(viewPdf);
    }
  }, [viewPdf, getExistingFileData]);

  return (
    <>
      {fileParseDone && [100, 0].includes(100)
        ? existingdataList.map((fileData, index) => {
            return (
              <>
                {fileData?.size > 0 && (
                  <PdfPreview key={index} file={fileData} />
                )}
              </>
            );
          })
        : null}
    </>
  );
};
export default memo(Pdfview);
